<script setup>
import Button from "~/components/common/Button.vue"

const props = defineProps({
  data: {
    type: Object,
    default: () => null
  }
})

const postLink = computed(() => {
  return `/blog/${props.data.base_path}/${props.data.slug}`
})
</script>

<template>
  <div class="flex flex-col col-span-12 md:col-span-6 lg:col-span-6 xl:col-span-3 mb-5 lg:mb-5 mt-5">
    <NuxtLink :to="postLink">
      <img class="w-full mb-2" :src="props.data.image" :alt="props.data.title" loading="lazy" />
    </NuxtLink>
    <div class="">
      <NuxtLink :to="postLink"><h2 class="italic text-3xl font-bold lg:text-3xl text-justify">{{ props.data.title }}</h2>
      </NuxtLink>
      <p class="text-md text-justify italic my-2">{{ props.data.excerpt }}</p>
    </div>
    <div class="flex justify-center mt-auto">
      <Button
        :to="postLink"
        label="Artículo Completo"
        class="buttonLoginfForm text-center"
        severity="primary"
      />
    </div>
  </div>
</template>
